
import { defineComponent, ref, reactive, onMounted, computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useHead } from '@vueuse/head'

import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const SeasonEntryRepository = RepositoryFactory.get('seasonEntry')
const SeasonRepository = RepositoryFactory.get('season')

import BaseBreadcrumb, { Breadcrumb } from '@/components/BaseBreadcrumb.vue'


import { EntryTeam } from '@/types/entryTeam'
import { Game } from '@/types/game'
import { RosterPlayer } from '@/types/rosterPlayer'
import { Season } from '@/types/season'

export default defineComponent({
  name: 'SeasonEntryDetail',
  components: {
    BaseBreadcrumb,
  },
  setup() {
    const route = useRoute()

    onMounted(() => {
      getSeason()
      getEntry()
    })

    watch(
      () => [route.params.team_id],
      () => {
        if (route.name === 'seasonEntryDetail') getEntry()
      }
    )

    const entry: {
      data?: EntryTeam
    } = reactive({
      data: undefined
    })

    const games: {
      list: Game[]

      isLoading: boolean
    } = reactive({
      list: [],

      isLoading: false
    })

    const rosters: {
      list: RosterPlayer[]

      isLoading: boolean
    } = reactive({
      list: [],

      isLoading: false
    })

    const getEntry = async () => {
      try {
        games.isLoading = true
        rosters.isLoading = true

        const { season_id, team_id } = route.params

        const res = await SeasonEntryRepository.getEntry(season_id, team_id)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          entry.data = data.entry_team
          games.list = data.games
          rosters.list = data.rosters
        }
      } catch (error) {
        //
      } finally {
        games.isLoading = false
        rosters.isLoading = false
      }
    }

    const season: {
      data?: Season
    } = reactive({
      data: undefined
    })

    const getSeason = async () => {
      try {
        const { season_id } = route.params

        const res = await SeasonRepository.getSeason(season_id)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          season.data = data.season
        }
      } catch (error) {
        //
      }
    }

    useHead({
      title: computed(() => entry.data?.team_name + ' - ' + season.data?.topic_name + season.data?.name),
    })

    const breadcrumbs = computed(() => {
      return [
        {
          type: 'link',
          link: {
            name: '大会一覧',
            path: '/'
          }
        },
        {
          type: 'link',
          size: 'large',
          link: {
            name: season.data?.topic_name,
            secondName: season.data?.name,
            path: '/event/' + route.params.topic_id + '/season/' + route.params.season_id,
          },
          setting: {
            path: '/event/' + route.params.topic_id
          }
        },
        {
          type: 'link',
          link: {
            name: 'エントリーチーム',
            path: '/event/' + route.params.topic_id + '/season/' + route.params.season_id + '/team'
          }
        },
        {
          type: 'text',
          text: {
            name: entry.data?.team_name,
            secondName: entry.data?.division
          }
        },
      ] as Breadcrumb[]
    })

    return {
      entry,
      games,
      rosters,
      getEntry,

      season,
      getSeason,

      breadcrumbs
    }
  }
})
